import { toast } from 'react-toastify';
import { expandPlans } from './monthlyRegistrationHelpers';

export const getArenaDetails = (arenaHash, baseUrl, urlParams, setStateCallback, getMonthlyPlansCallback) => {
  fetch(`${baseUrl}/parking/arena/details?arena_hash=${arenaHash}`)
    .then((response) => response.json())
    .then((resp) => {
      if (resp.data && resp.status === 'SUCCESS') {
        const data = resp.data;
        const is45SECase = data.id === 5832;
        const is207CollegeSt = data.id === 5999;
        const is700BiscayneLot = data.id === 6029;
        let showTemplate = urlParams.get('pricing_type');
        showTemplate = is45SECase && showTemplate == "city_national_bank" ? false : showTemplate;
        
        setStateCallback(
          {
            timeZone: data.timezone,
            parkingId: data.id,
            is45SECase,
            showTemplate,
            arenaName: data.name,
            lotType: data.lot_types,
            isEnforcement: data.enforcement_enabled,
            is700BiscayneLot,
            is207CollegeSt,
            currentStep: 1
          },
          () => getMonthlyPlansCallback(data.id)
        );
      } else {
        const errorMessage = (resp.error && resp.error.reason) || 'Something went wrong';
        setStateCallback({
          loading: false,
          error: errorMessage
        });
        toast.error(errorMessage);
      }
    })
    .catch((error) => {
      setStateCallback({
        loading: false,
        error: 'Something went wrong'
      });
      toast.error('Something went wrong');
    });
};

export const getMonthlyPlans = (parkingId, baseUrl, state, setStateCallback) => {
  fetch(`${baseUrl}/parking/monthly/pricing/list?parking_id=${parkingId}`)
    .then((response) => response.json())
    .then((resp) => {
      if (resp.data && resp.status === 'SUCCESS') {
        let respPricingCopy = resp.data.pricing && resp.data.pricing.length ? JSON.parse(JSON.stringify(resp.data.pricing)) : [];
        
        if(state.showTemplate){
          let templateName = state.showTemplate.replaceAll('_', ' ').toLowerCase();
          respPricingCopy.forEach(obj => {
            if(obj.pricing_data)
            obj.pricing_data.visible = obj.pricing_type && obj.pricing_type.toLowerCase() === templateName  ? true : false; 
          })
        }
        
        const originalPassList = !resp.data.new_subscription_allowed ? [] : respPricingCopy && respPricingCopy.length ?
                                    state.visible !== "false" ?
                                    respPricingCopy.filter(item => item.pricing_data && (!item.pricing_data.hasOwnProperty('visible') || item.pricing_data.visible)) 
                                    : respPricingCopy.filter(item => item.pricing_data && item.pricing_data.visible === false) 
                                    : [];
        
        const filteredByStatus = originalPassList.filter(item => item.status === 'active');
        const expandedPlans = expandPlans(filteredByStatus);
        
        setStateCallback({
          passList: expandedPlans,
          originalPassList: expandedPlans,
          loading: false,
          isAutoApproval: resp.data.request_auto_approved || false
        });
      } else {
        const errorMessage = (resp.error && resp.error.reason) || 'Something went wrong';
        setStateCallback({
          loading: false,
          error: errorMessage
        });
        toast.error(errorMessage);
      }
    })
    .catch(() => {
      setStateCallback({
        loading: false,
        error: 'Something went wrong'
      });
      toast.error('Something went wrong');
    });
};

export const calculateAccountPrice = (state, baseUrl, urlParams, setStateCallback) => {
  let params = '';
  const { selectedPlan, no_of_spots, parkingId } = state;
  
  if (selectedPlan && selectedPlan.pricing_data && selectedPlan.pricing_data.is_reserve_spot) {
    params = `parking_id=${parkingId}&slot_count=${no_of_spots}&pass_type=${selectedPlan ? selectedPlan.pricing_type : ''}&reserve_spot=true`;
  } else {
    params = `parking_id=${parkingId}&slot_count=${no_of_spots}&pass_type=${selectedPlan ? selectedPlan.pricing_type : ''}&reserve_spot=false`;
  }
  
  setStateCallback({ loadingPricing: true });
  
  fetch(`${baseUrl}/parking/monthly/bulk/pricing?${params}`)
    .then((response) => response.json())
    .then((resp) => {
      if (resp.data && resp.status === 'SUCCESS') {
        const subscriptionType = state.selectedPlan?.subscriptionType || 'individual';
        const isPayment = urlParams.get('pay') === "true" && subscriptionType === 'individual' ? true : subscriptionType === 'individual' && resp.data.is_payment ? true : false;
        
        setStateCallback({
          monthlyAccountPrice: resp.data.rental_amount / 100,
          rentalFee: resp.data.rental_fee,
          convFee: resp.data.conv_fee,
          reservedSpot: resp.data.reserved_spot,
          isPayment: isPayment,
          terms: resp.data.terms ? resp.data.terms : [],
          loadingPricing: false,
          currentStep: 2
        });
      } else {
        const errorMessage = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
        toast.error(errorMessage);
        setStateCallback({ loadingPricing: false });
      }
    })
    .catch((error) => {
      toast.error('Something went wrong');
      setStateCallback({ loadingPricing: false });
    });
};

export const submitRequest = (submitRequestData, baseUrl, env, state, setStateCallback, manageBodyBackground) => {
  const istypeAccount = submitRequestData.type === 'account';
  const apiUrl = istypeAccount
    ? `${baseUrl}/parking/monthly/account/request`
    : `${baseUrl}/parking/monthly/user/request`;
  
  setStateCallback({ submittingForm: true });
  
  fetch(apiUrl, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(submitRequestData)
  })
    .then((response) => response.json())
    .then((resp) => {
      if (resp.status === 'SUCCESS' && resp.data) {
        const subscriptionId = istypeAccount ? resp.data.account_hash : resp.data.pass_hash;
        const isAccountAndPayByIndividual = istypeAccount && submitRequestData.payment_type === 'individual';
        
        if (isAccountAndPayByIndividual) {
          manageBodyBackground(false);
          setStateCallback({ booked: true, submittingForm: false });
          return;
        }
        
        if (!state.isAutoApproval) {
          manageBodyBackground(false);
          setStateCallback({ booked: true, submittingForm: false });
          return;
        }
        
        if(env === 'prod'){
          window.location.href = istypeAccount ? `https://monthly.parkquility.com/account?id=${subscriptionId}` : 
                                              `https://monthly.parkquility.com?id=${subscriptionId}`;
        }else{
          window.location.href = istypeAccount ? `https://${env}monthly.parkquility.com/account?id=${subscriptionId}` : 
                                              `https://${env}monthly.parkquility.com?id=${subscriptionId}`
        }
      } else {
        const errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
        setStateCallback({ submittingForm: false });
        toast.error(errMsg);
      }
    })
    .catch((error) => {
      setStateCallback({ submittingForm: false });
      toast.error('Something went wrong');
    });
};

